<template>
    <div class="cs-block cs-faq-block" :class="styleClass">
        <div class="cs-base-block">
            <div class="container">
                <div class="header-content">
                    <h2 class="cs-title" v-if="data.title">
                        <ColorSplit :data="data.title" />
                    </h2>
                    <h3 class="cs-sub-title" v-if="data.subTitle">{{data.subTitle}}</h3>
                    <span class="cs-text" v-html="data.text"></span>
                </div>
                <div class="search-input">
                    <input
                        class="search-input__item"
                        type="text"
                        v-model="searchField"
                    />
                    <i class="bi bi-search"></i>
                </div>

                <div class="buttons">
                    <button
                        class="grey-button"
                        v-for="(tag, tagKey) in data.tags"
                        :key="tagKey"
                        @click="filterTags(tag._id)"
                    >
                        {{ tag.title }}
                    </button>
                </div>

                <div id="accordion" class="d-flex flex-column">
                    <div 
                        class="card" 
                        v-for="(item, index) in faqs" 
                        :key="index" 
                        :id="`card${index}`" 
                        @click="showBorder(index)"
                    >
                        <div
                            class="card-header"
                            id="headingOne"
                            data-toggle="collapse"
                            :data-target="`#collapseOne${index}`"
                            aria-expanded="true"
                            :aria-controls="`collapseOne${index}`"
                            @click="hideButton(index)"
                        >
                            <div class="mb-0 d-flex justify-content-between align-items-center">
                                <span class="font-weight-bold p-0">
                                    {{ item.title }}
                                </span>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.79395 5.57819L7.79395 10.5782L12.7939 5.57819L2.79395 5.57819Z"/>
                                </svg>
                                <span class="dash"></span>
                            </div>
                        </div>

                        <div
                            :id="`collapseOne${index}`"
                            class="collapse"
                            aria-labelledby="headingOne"
                            data-parent="#accordion"
                        >
                            <div class="card-body">
                                <p v-html="item.answer"></p>
                                <div class="buttons">
                                    <button
                                        v-for="(tag, idx) in item.tags"
                                        :key="idx"
                                        class="tag-button"
                                    >
                                        {{ tag }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FAQ',
    components: {
        ColorSplit: () => import("../blocks_components/ColorSplit.vue"),
    },
    data() {
        return {
            faqs: [],
            searchField: ''
        }
    },
    props: {
        data: {
            type: Object,
            default: () => {}
        }
    },
    mounted() {
        this.faqs = this.data.faqs;
        console.log(this.data)
    },
    methods: {
        hideButton(index) {
            const cardHeader = document.querySelector(`#headingOne[data-target="#collapseOne${index}"]`);
            if (!cardHeader.classList.contains('collapsed')) {
                cardHeader.classList.toggle('hide-button');
            } 
        },
        showBorder(index){
            const cardHeader = document.querySelector(`#headingOne[data-target="#collapseOne${index}"]`);
            const card = document.querySelector(`#card${index}`);
            if (!cardHeader.classList.contains('collapsed')) {
                card.classList.toggle('bordered')
            }

        },
        filterTags(tag) {
            const lowerCaseTag = tag.toLowerCase().trim();
            this.faqs = this.data.faqs.filter((faq) => {
                return faq.tags.some((t) => t.toLowerCase().includes(lowerCaseTag));
            });
        },
    },

    computed: {
        styleClass(){
            let result = ''

            if(this.data.style) result += ` cs-style-${this.data.style}`;

            return result
        },
    },
    watch: {
        searchField() {
            this.filterTags(this.searchField);
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../styles/main.scss';
.cs-faq-block {
    &.cs-style- {
        &color {
            @include cs-block-color;
            .cs-title {
                color: white
            }
            .cs-sub-title {
                color: $sub_title_color;
            }

            .cs-text {
                color: $text_color_over_theme_color;

                ::v-deep {
                    * {
                        color: $text_color_over_theme_color !important;
                    }
                }
            }
            .search-input {
                &__item {
                    border-color: $text_color_over_theme_color;
                    color: $text_color_over_theme_color;
                }
                i {
                    color: $text_color_over_theme_color;
                }
            }
            .card-header {
                border-color: $text_color_over_theme_color;
                color: $text_color_over_theme_color;
                .arrow {
                    fill: $text_color_over_theme_color;
                }
                .dash {
                    background-color: $text_color_over_theme_color;
                }
            }
            .card-body {
                p {
                    ::v-deep {
                        color: $text_color_over_theme_color;
                    }
                }
            }
        }

        &light {
            @include cs-block-light;

            .cs-sub-title {
                color: $sub_title_color_dark;
            }
        }

        &dark {
            @include cs-block-dark;
            .cs-sub-title {
                color: $sub_title_color_dark;
            }
        }
    }
    .header-content {
        text-align: center;
        margin-bottom: $header_margin;
        &:last-child {
            margin-bottom: 0;
        }
        .cs-title, .cs-sub-title {
            margin-bottom: 20px;
        }
        .cs-text {
            ::v-deep {
                * {
                    text-align: center;
                }
                img {
                    max-width: 100%;
                    height: 300px;
                    border-radius: 10px;
                    margin: 10px;
                }
                p,
                span {
                    @include text;
                }
                *:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
    .search-input {
        margin-top: $theme_items_margin;
        display: block;
        position: relative;
        width: 100%;

        &__item {
            display: block;
            width: 100%;
            height: 40px;
            border: 1px solid #000;
            padding: 25px 15px 25px 40px;
            outline: none;
            border-radius: 30px;
            color: #000;
            background: transparent;
            &::placeholder {
                color: $labels_color;
            }
        }

        & i {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            padding-left: $block_space;
            cursor: pointer;
            font-size: 20px !important;
            @include text;
        }
    }
    .buttons {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin: $theme_items_margin 0 !important;
        @include text;

        .grey-button,
        .tag-button {
            background-color: #E4EEF7;
            color: $labels_color;
            border: none;
            padding: 10px 20px;
            border-radius: 25px;
            @include base-transition;
            &:hover {
                opacity: .7;
            }
        }
    }
    .arrow {
        fill: #000;
    }
    .card {
        border-radius: 0;
        border: none;
        background: transparent;
        &.bordered {
            border: 1px solid #000;
            border-radius: 25px;
            margin-bottom: 5px;
            .card-header {
                border: none;
            }
            .card-body {
                border-radius: 25px;
            }
        }
    }
    .card-header {
        border-radius: 25px;
        margin-bottom: 10px;
        border: 1px solid #000;
        padding: 15px 15px 15px 20px;
        background-color: transparent;
        cursor: pointer;
        &.hide-button {
            .arrow {
                display: none;
            }
            .dash {
                display: block;
            }
        }
    }
    #accordion {
        margin-top: 30px;
    }
    .card-body {
        padding: 20px 20px 20px 30px;
        p {
            ::v-deep {
                color: $primary_text_color;
                img {
                    max-width: 100%;
                    height: 300px;
                    border-radius: 10px;
                    margin: 10px;
                }
                &:last-child {
                    margin: 0;
                }
            }
        }
    }
    .dash {
        height: 4px;
        width: 14px;
        background-color: #000;
        display: none;
    }
}
</style>
